import { observer } from 'mobx-react';
import { Outlet } from 'react-router-dom';

import { appStore } from '../stores/app-store';
import { Spinner } from '../components/spinner';
import AdministrationMenu from './administration-menu';
import { ToastProvider } from '../contexts/toast-context';
import { AuthRequired } from '../components/authentication';

/**
 * The layout for admin portal pages.
 * @returns
 */
const Administration = observer(() => {
  return (
    <AuthRequired>
      <ToastProvider>
        <div className={'layout layout--admin'}>
          {appStore.isLoading() && <Spinner />}
          <AdministrationMenu />
          <div className={'app-main'}>
            <Outlet />
          </div>
        </div>
      </ToastProvider>
    </AuthRequired>
  );
});

export default Administration;
